const firebaseConfig = {
    apiKey: "AIzaSyCrG-OZ4jMEpztgzwnOtYEt5nIDiFGkwI8",
    authDomain: "care-seller.firebaseapp.com",
    projectId: "care-seller",
    storageBucket: "care-seller.appspot.com",
    messagingSenderId: "1044406125958",
    appId: "1:1044406125958:web:3581ffa040131d36f69807",
    measurementId: "G-PP2YGY0D27"
};

export default firebaseConfig;